import { Button, FontWeights } from "@flat-ui";
import ArrowLeftIcon from "@assets/icons/arrow-left_24px.svg?react";

interface Props {
  /** Callback execute on button click */
  handleBack(): void;

  /** Whether the back button is in a loading state */
  isLoading?: boolean;
}

/** Button to navigate to the previous step of a signup flow */
export function SignupBackButton({
  handleBack,
  isLoading = false,
}: Props): JSX.Element {
  return (
    <Button
      variant="ghost"
      icon={<ArrowLeftIcon />}
      onClick={handleBack}
      isLoading={isLoading}
      sx={{
        width: "100%",
        marginBottom: "16px",
        textTransform: "none",
        fontWeight: FontWeights.SemiBold,
      }}
    >
      Return to previous screen
    </Button>
  );
}
